import React from 'react';
import './Componenst.css';
import OPMModel from '../models/OPMModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createOPM, showError } from '../ViewCreator';

function OPM({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new OPMModel();


    const clearSubmit = () => {
        document.getElementById('storage').value     = '';
    document.getElementById('ini_name').value     = '';
    document.getElementById('ini_direction').value     = '';
    document.getElementById('ini_organ').value     = '';
    document.getElementById('executor').value     = '';
    document.getElementById('typeExecutor').value     = '';
    document.getElementById('dateOPM').value     = '';
    document.getElementById('numberOPM').value     = '';
    personModel.storage = ''
    personModel.ini_name = ''
    personModel.ini_direction = ''
    personModel.ini_organ = ''
    personModel.executor = ''
    personModel.typeExecutor = ''
    personModel.dateOPM = ''
    personModel.numberOPM = ''
    if (searchModel != undefined ) {
      searchModel.opm.storage = ''
      searchModel.opm.ini_name = ''
      searchModel.opm.ini_direction = ''
      searchModel.opm.ini_organ = ''
      searchModel.opm.executor = ''
      searchModel.opm.typeExecutor = ''
      searchModel.opm.dateOPM = ''
      searchModel.opm.numberOPM = ''
    }
    }

    const addSubmit = () => {
     
    if (personModel.numberOPM == undefined || personModel.numberOPM == '') {
        showError('Номер не може бути пустим')
        return;
    }

    if (personModel.dateOPM == undefined || personModel.dateOPM == '') {
        showError('Дата не може бути пустою')
        return;
    }

    if (personModel.typeExecutor == undefined || personModel.typeExecutor == '') {
        showError('Підрозділ виконавця не може бути пустим')
        return;
    }
    
    if (personModel.executor == undefined || personModel.executor == '') {
      showError('Виконавець не може бути пустим')
      return;
  }

        isUniq()
  }

  const isUniq = () => {
      var path = ip + '/api/opm/search';
      personModel.searchModel = new SearchModel()
      var pp = new OPMModel();
      pp.numberOPM = personModel.numberOPM
      pp.dateOPM = personModel.dateOPM
      pp.typeExecutor = personModel.typeExecutor
      pp.executor = personModel.executor
      var bd = encryptAes(JSON.stringify(pp))
      const requestOptions = {
        headers: {
          'Content-Type': 'Content-type: text/html'
        },
        credentials: 'include',
        uri: path,
        encoding: 'latin1',
        body: bd,
        method: 'POST'
      };
      fetch(path, requestOptions)
        .then()
        .then(response => { return response.arrayBuffer() })
        .then((buffer) => {
          const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
          const text = decoder.decode(buffer);
          try {
            var result = JSON.parse(text);
             showError(result.msg)
          } catch (error) {
            const decryptedText = decryptAes(text);
            var result = JSON.parse(decryptedText);
            storeKey('test_data', result.key);
  
            if (result.data.length > 0) {
              Swal.fire({
                  title: 'Запис уже існує',
                  //text: "Оновити інформацію?",
                  icon: 'warning',
                  html:
                  'Запис з такими даними вже існує, Ви можете ' +
                  '<a href="/opm?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'ОК',
                    denyButtonText: 'Оновити',
                    background: '#2B2B2B',
                    color: '#FFF'
                  }).then((result) => {
                  })
                sendSearch()
            } else {
              Swal.fire({
                title: 'Ви дійсно бажаєте створити новий запис',
                //text: "Оновити інформацію?",
                icon: 'question',
                html:
                '',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Створити',
                denyButtonText: 'Оновити',
  
                background: '#2B2B2B',
                color: '#FFF'
              }).then((result) => {
                addNewOPM()
                })
              
            }
          }
        })
    }

    const addNewOPM = () => {
      var path = ip + '/api/opm/add';
      personModel.searchModel = new SearchModel()
      var bd = encryptAes(JSON.stringify(personModel))
      const requestOptions = {
        headers: {
          'Content-Type': 'Content-type: text/html'
        },
        credentials: 'include',
        uri: path,
        encoding: 'latin1',
        body: bd,
        method: 'POST'
      };
      fetch(path, requestOptions)
        .then()
        .then(response => { return response.arrayBuffer() })
        .then((buffer) => {
          const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
          const text = decoder.decode(buffer);
          try {
            var result = JSON.parse(text);
             showError(result.msg)
            
  
          } catch (error) {
            const decryptedText = decryptAes(text);
            var result = JSON.parse(decryptedText);
            storeKey('test_data', result.key);
            if (isAdd) {
              addNew(result.data, 20008)
              clearSubmit()
            } else {
            window.open("/edit/opm?id="+result.data, "_self")
            }
          }
        })
    }

    const sendOPMFullScreen = (id) => {
        window.open("/opm?id=" + id)
    }

    const sendOPM = (id) => {
        var path = ip + '/api/opm/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createOPM(addr))
    
                    String.prototype.replaceAt = function(index, replacement) {
                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                      }
                      var spr =  document.createElement('div');
                      spr.className = "spravka"
                      
                      spr.innerHTML = "<hr><p>"+addr.infoOPM.replace(/\r\n/g, "<p>"); 
                      zz.push(spr)

                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/opm/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        var t = "<p align=\"left\">"+pers.numberOPM +" " + pers.dateOPM+ "<br>"+ pers.typeExecutor+ " "; 
                        if (pers.executor != undefined) t += pers.executor;
                        t += "<br>"; 
                        if (pers.ini_organ != undefined)t += pers.ini_organ+" ";
                        if (pers.ini_name != undefined)t += pers.ini_name + " ";
                        if (pers.ini_direction != undefined)t += pers.ini_direction;
                        z.innerHTML = t;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendOPM(i)
                        }
                        const dblcl = i => () => {
                            sendOPMFullScreen(i)
                        }
                       // z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new OPMModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                              if(id=='numberOPM'){
                        
                                personModel.numberOPM = l[index]
                                
                              }
        
                              if(id=='ini_organ'){
                                
                                personModel.ini_organ = l[index]
                                
                              }
        
                              if(id=='ini_direction'){
                                
                                personModel.ini_direction = l[index]
                                
                              }
        
                              if(id=='ini_name'){
                                
                                personModel.ini_name = l[index]
                                
                              }
        
                              if(id=='executor'){
                                
                                personModel.executor = l[index]
                                
                              }
        
                              if(id=='storage'){
                                
                                personModel.storage = l[index]
                                
                              }
        
                              if(id=='dateOPM'){
                                
                                personModel.dateOPM = l[index]
                                
                              }
        
                              if(id=='typeExecutor'){
                                
                                personModel.typeExecutor = l[index]
                                
                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }

      const numberOPMchange = () =>  {
        personModel.numberOPM = document.getElementById('numberOPM').value
        changedfield('numberOPM');
      }
    
      const dateOPMchange = () =>  {
        personModel.dateOPM = document.getElementById('dateOPM').value
        changedfield('dateOPM');
      }
    
      const ini_organchange = () =>  {
        personModel.ini_organ = document.getElementById('ini_organ').value
        changedfield('ini_organ');
      }
    
      const ini_directionchange = () =>  {
        personModel.ini_direction = document.getElementById('ini_direction').value
        changedfield('ini_direction');
      }
    
      const ini_namechange = () =>  {
        personModel.ini_name = document.getElementById('ini_name').value
        changedfield('ini_name');
      }
    
      const executorchange = () =>  {
        personModel.executor = document.getElementById('executor').value
        changedfield('executor');
      }
    
      const storagechange = () =>  {
        personModel.storage = document.getElementById('storage').value
        changedfield('storage');
      }
    
      const namechange = () =>  {
        personModel.dateOPM = document.getElementById('dateOPM').value
        changedfield('dateOPM');
      }
    
      const typeExecutorchange = () =>  {
        personModel.typeExecutor = document.getElementById('typeExecutor').value
        changedfield('typeExecutor');
      }





    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-opm" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-opm" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-opm" className="input-button-right" type="submit" value="Пошук" />

          <div id="storageDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="storage" className="input-text" tabIndex="8" name="login" type="text" onChange={storagechange}  placeholder="Зберігання" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="storageList" className="list" />
          </div>

          <div id="ini_nameDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ini_name" className="input-text" tabIndex="7" name="login" type="text" onChange={ini_namechange}  placeholder="Ініціатор" autoComplete="off"onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="ini_nameList" className="list" />
          </div>

          <div id="ini_directionDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ini_direction" className="input-text" tabIndex="6" name="login" type="text" onChange={ini_directionchange}  placeholder="Відділ ініціатора" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="ini_directionList" className="list" />
          </div>

          <div id="ini_organDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ini_organ" className="input-text" tabIndex="5" name="login" type="text" onChange={ini_organchange}  placeholder="Підрозділ ініціатора" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="ini_organList" className="list" />
          </div>

          <div id="executorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="executor" className="input-text" tabIndex="4" name="login" type="text" onChange={executorchange}  placeholder="Виконавець" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="executorList" className="list" />
          </div>

          <div id="typeExecutorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeExecutor" className="input-text" tabIndex="3" name="login" type="text" onChange={typeExecutorchange}  placeholder="Підрозділ виконавця" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="typeExecutorList" className="list" />
          </div>

          <div id="dateOPMDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="dateOPM" className="input-text" tabIndex="2" name="login" type="text" onChange={dateOPMchange}  placeholder="Дата" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="dateOPMList" className="list" />
          </div>

          <div id="numberOPMDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberOPM" className="input-text" tabIndex="1" name="login" type="text" onChange={numberOPMchange}  placeholder="Номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="numberOPMList" className="list" />
          </div>






            </form>
        </div>
    );
}

export default OPM;